<template>
<div 
   :style="$props.style"
   class='info-item'
   :class="{ 'noline': noline, [`${$props.class}`]: true, 'info-title': title, }"
   >
   <div v-if="!nomarker" class="marker"/>
   <div v-if="Array.isArray(value)" class='array-type'>
      <span class='label'>{{ name }}: </span>
      <span class='value'>
         <div
            v-for="(in_value,index) in value"
            :key="index"
            class='inner-value'
            >
            &bull; {{ in_value }}
         </div>
      </span>
   </div>
   <div v-else-if="(value instanceof Object)" class='object-type'>
      <span class='label'>{{ name }}: </span>
      <div class='value'>
         <div
            v-for="([in_name,in_value], index) in Object.entries(value)"
            :key="index"
            >
            <span class='inner-label'>{{ in_name }}:</span>
            <span class='inner-value'>{{ in_value }}</span>
         </div>
      </div>
   </div>
   <div v-else
      >
      <span class='label'>{{ name }}: </span>
      <span class='value'>{{ value }}</span>
   </div>   
</div>
</template>

<script>
export default {
   name: 'info-item',
   props: {
      name: {
         type: String,
         required: true,
      },
      value: {
         type: [String, Object, Number, Array],
         required: true,
      },
      noline: {
         type: Boolean,
         default: false,
      },
      title: {
         type: Boolean,
         default: false,
      },
      nomarker: {
         type: Boolean,
         default: false,
      }
   },
}
</script>

<style lang="scss" scoped>
.info-item {
   position: relative;
   font-family: $primary-font;
   border-top: solid 1px rgba($primary-color, 0.1);
   width: 100%;
   color: $font-color;
   transition: all 0.4s linear;
   
   &:hover:not(.info-title) {
      background: $primary-color;
      color: white;
      transform: scale(1.02);
      .marker::before {
         background: $secondary-bg;
      }
   }

   &.noline {
      border: none;
      line-height: 2;
      .marker::before {
         transform: translateY(100%);
      }

   }
   &.info-title span {
      font-weight: bold;
      border-bottom: solid 1px rgba($primary-color, 0.2);
   }
   .marker {
      filter: drop-shadow(2px 1px 3px rgba($primary-color, 0.25));
      position: absolute;
   }
   .marker::before {
      content: "";
      position: absolute;
      transition: all 0.3s ease-in;
      display: flex;
      align-items: center;
      justify-content: center;
      left: -0.15em;
      transform: translateY(70%);
      height: 0.9em;
      width: 1em;
      background: $primary-color;
      clip-path: polygon(68% 0, 100% 50%, 68% 100%, 0 100%, 0 0);
      // filter: drop-shadow(2px 2px 3px $primary-color);
   }

   span {
      font-size: 0.95em;
      display: inline-block;
      padding: 0.5em 2.2em;
   }
   .label{
      width: 50%;
   }
   .value {
      display: inline-block;
      width: 50%;
      font-weight: 600;
      padding-left: 0;
   }
   .object-type,
   .array-type {
      padding: 0;
      display: flex;
      justify-content: flex-start;
      &:first-child {
         border-color: rgba($primary-color, 0.15);
      }
      .value {
         $padding: 0.3em;
         padding: 0 0 $padding 0;
         .inner-label,
         .inner-value {
            padding: $padding 0 0 0;
         }
         .inner-label {
            margin-right: 0.5em;
         }
      }
   }
}
</style>